<div class="py-5 text-center">
    <h6 class="text-sm font-normal mb-0">No campaigns to show!</h6>
    <img class="block mx-auto" src="/assets/img/template-empty-state-img.svg" alt="Image" />
  </div>